var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnassigned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.267 11.985.766-.766a.74.74 0 0 0 0-1.073.742.742 0 0 0-1.073 0l-.766.766-.767-.767a.742.742 0 0 0-1.072 0 .742.742 0 0 0 0 1.074l.766.766-.69.69a.74.74 0 0 0 0 1.072.74.74 0 0 0 1.074 0l.689-.69.766.767c.153.153.383.23.536.23a.827.827 0 0 0 .537-.23.74.74 0 0 0 0-1.073l-.766-.766zM11.89 4.858c.076-1.916-1.533-3.525-3.525-3.525A3.515 3.515 0 0 0 4.84 4.858a3.515 3.515 0 0 0 3.525 3.525 3.516 3.516 0 0 0 3.525-3.525z",
    fill: "#E99514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.598 9.916c-1.073 0-2.069.153-2.835.383-.46.154-.92.383-1.227.69A1.85 1.85 0 0 0 3 12.292c0 .536.153.92.536 1.302.307.306.767.537 1.227.69.766.23 1.762.382 2.835.382.46 0 .766-.306.766-.766v-3.218c0-.46-.307-.766-.766-.766z",
    fill: "#E99514"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassigned);
export default __webpack_public_path__ + "static/media/unassigned.2ac8aa001e75f1ce1b87c53bea1c6289.svg";
export { ForwardRef as ReactComponent };